var React = require('react');

function BerninoLeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.299624 6.46419L4.12362 0.992188H5.49962L1.88363 6.01619L11.5156 5.95219V7.04019L1.88363 6.97619L5.48362 12.0002H4.13962L0.299624 6.46419Z","fill":"black"}));
}

BerninoLeftArrow.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = BerninoLeftArrow;

BerninoLeftArrow.default = BerninoLeftArrow;
